import { PortfolioForwardCurvesStep } from "../components/steps/PortfolioForwardCurvesStep";
import { PortfolioInfoStep } from "../components/steps/PortfolioInfoStep";
import { PortfolioMarketModelStep } from "../components/steps/PortfolioMarketModelStep";
import { StepDisplayModel, StepStateModel } from "../models/StepModel";
import React from "react";

export const portfolioWizardTypes = [
    { label: "Econ Dispatch", optionValue: "EconDispatch", enabled: true },
    { label: "Load Dispatch", optionValue: "LoadDispatch", enabled: false },
    { label: "Automated Resource Selection (ARS)", optionValue: "ARS", enabled: false },
];

const skipStep = [
    { label: "Select Items", optionValue: 1, enabled: true },
    { label: "Skip Selection", optionValue: 0, enabled: true },
];


//Start with "Econ Dispatch" as the only available option and gray out "Load Dispatch" and "Automated Resource Selection (ARS)"

export const wizardStepsDefinitionEconDispatch: StepDisplayModel[] = [
    {
        title: 'Input portfolio name, book, description',
        description: 'Basic Portfoli Info',
        component:
            <PortfolioInfoStep 
                saveActiveStepState={function (activeStep: number, progress: StepStateModel): void {
                    throw new Error("Function not implemented.");
                } } 
                stepsSavedState={[]} 
                title={""} 
                stepIdx={0} 
                setIsStepValid={function (isValid: boolean): void {
                    throw new Error("Function not implemented.");
                } } 
            />
    },
    {
        title: 'Select Main Market Model',
        description: 'Display a list of available market models and allow the user to select one. The selected market model will be used as the main market for the portfolio.',
        priorStepIdx: 0,
        component: <PortfolioMarketModelStep 
            saveActiveStepState={function (activeStep: number, progress: StepStateModel): void {
                throw new Error("Function not implemented.");
            } } 
            stepsSavedState={[]} 
            title={""} 
            stepIdx={0} 
            setIsStepValid={function (isValid: boolean): void {
                throw new Error("Function not implemented.");
            } } 
        />
    },
    {
        title: 'Select Forward Curves',
        description: ' Display a list of available forward curves and allow the user to select one or more. Forward curves that are connected to the main market are automatically selected and cannot be unchecked. Give the user the option to select additional forward curves.',
            
        priorStepIdx: 1,
        component: <PortfolioForwardCurvesStep 
            saveActiveStepState={function (activeStep: number, progress: StepStateModel): void {
                throw new Error("Function not implemented.");
            } } 
            stepsSavedState={[]} 
            title={""} 
            stepIdx={0} 
            setIsStepValid={function (isValid: boolean): void {
                throw new Error("Function not implemented.");
            } } 
        />
    },
    {
        title: 'Select Forward Curves Constraints',
        description: 'Display a list of available forward curves constraints and allow the user to select one or more. Display a warning for not having a forward curve.',
        priorStepIdx: 2,
        component: <>
        <h1>HTML component typeof child.type === string</h1>
        <ul>
            <ol>FCC1</ol>
            <ol>FCC2</ol>
            <ol>FCC3</ol>
            <ol>FCC4</ol>
            <ol>FCC5</ol>
            <ol>FCC6</ol>
        </ul>
        </>
    },
    { title: 'Select Global Shapes', 
        description: 'Display a list of available Global Shapes and allow the user to select one or more. Display a warning for spot price not matching.', 
        priorStepIdx: 3,
        component: <h1>This is Step Global Shapes</h1> 
    },
    { title: 'Select Renewables', 
        description: 'Ask if the user wants to include Renewables. If yes, display a list of available Renewables and allow the user to select one or more. If no, go to next step.', 
        priorStepIdx: 4,
        stepOptions: skipStep,
        component: <h1>This is Step Renewables</h1> 
    },
    { title: 'Select Batteries', 
        description: 'Ask if the user wants to include Batteries. If yes, display a list of available Batteries and allow the user to select one or more. If no, go to next step', 
        priorStepIdx: 5,
        stepOptions: skipStep,
        component: <h1>This is Step Batteries</h1> 
    },
    { title: 'Select Thermal', 
        description: 'Ask if the user wants to include Thermal. If yes, display a list of available Thermal and allow the user to select one or more. If no, go to next step ', 
        priorStepIdx: 6,
        stepOptions: skipStep,
        component: <h1>This is Step Thermal</h1> 
    },
    { title: 'Select Hydro Items', 
        description: 'Ask if the user wants to include Hydro. If yes, display a list of available Hydro items and allow the user to select one or more. If no, go to next step', 
        priorStepIdx: 7,
        stepOptions: skipStep,
        component: <h1>This is Step Hydro</h1> 
    },
    { title: 'Select Hydro Projects', 
        description: 'Ask if the user wants to include Hydro Projects. If yes, display a list of available Hydro projects and allow the user to select one or more. If no, go to next step ', 
        priorStepIdx: 8,
        stepOptions: skipStep,
        component: <h1>This is Step Projects</h1> 
    },

    { title: 'Select Ancillaries', 
        description: 'If the user has selected either Batteries or a Thermal item or a Hydro Project, ask if Ancillaries will be included. If yes, display ancillary items. If no, go to next step   ', 
        priorStepIdx: 9,
        stepOptions: skipStep,
        component: <h1>This is Step Ancillaries</h1> 
    },
    { title: 'Select Load', 
        description: 'Ask if the user wants to include Load. If yes, display a list of available Load items and allow the user to select one or more. If no, go to next step ', 
        priorStepIdx: 10,
        stepOptions: skipStep,
        component: <h1>This is Step Load</h1> 
    },
    { title: 'Select Contracts/Hedges', 
        description: 'Ask if the user wants to include Physical and Financial Instruments. If yes, display a list of available Physical and Financial Instruments items and allow the user to select one or more. If no, go to next step ', 
        priorStepIdx: 11,
        component: <h1>This is Step Contracts</h1> 
    },
];